import { useState, useEffect } from 'react';
import { reactive } from '@/core/reactive/reactive';
import { withUser } from '@livefree/react-oauth2';
import { Apps, ProfileForm, TwoFactorSetup } from '@/features/profile';
import { Tabs, Tab, Spinner } from '@heroui/react';

export const Profile = withUser(
  reactive.component(
    ({ user, services, monitors, data }) => {
      const [tab, setTab] = useState('apps');

      useEffect(() => {
        services.my.profile();
        services.my.applications();
        services.my.twoFactor();
      }, [user.id, services]);

      return (
        <Tabs
          fullWidth
          classNames={{
            panel: 'mt-2',
          }}
          selectedKey={tab}
          onSelectionChange={setTab}
        >
          <Tab key="apps" title="Applications">
            {monitors.applications.executing && (
              <div className="flex justify-center w-full">
                <Spinner label="Loading..." />
              </div>
            )}
            {monitors.applications.complete && <Apps applications={data.applications} />}
          </Tab>
          <Tab key="profile" title="Profile">
            {monitors.profile.executing && (
              <div className="flex justify-center w-full">
                <Spinner label="Loading..." />
              </div>
            )}
            {monitors.profile.complete && <ProfileForm user={data.user} />}
          </Tab>
          <Tab key="twofactor" title="Security">
            {monitors.twoFactor.executing && (
              <div className="flex justify-center w-full">
                <Spinner label="Loading..." />
              </div>
            )}
            {monitors.twoFactor.complete && <TwoFactorSetup />}
          </Tab>
        </Tabs>
      );
    },
    {
      name: 'Profile',
      monitors: services => [services.my.profile, services.my.applications, services.my.twoFactor],
      queries: props => [
        {
          name: 'user',
          execute: db => props.user && db.users.get(parseInt(props.user.id, 10)),
          defaultValue: {},
          deps: [props.user.id],
        },
        {
          name: 'applications',
          execute: db => props.user && db.applications.toArray(),
          defaultValue: [],
          deps: [props.user.id],
        },
      ],
    },
  ),
);
